class EmbedCover {
	constructor(
		blockSelector = '[data-embed-cover="block"]', // block first ancestor selector
		holderSelector = '[data-embed-cover="holder"]', // iframe and cover holder selector
		coverSelector = '[data-embed-cover="cover"]' // cover selector
	) {

		this.blockSelector = blockSelector;
		this.holderSelector = holderSelector;
		this.coverSelector = coverSelector;
		this.embedList = [];
		this.embedCurrentTime = [];

		this.embedBlocks = document.querySelectorAll(this.blockSelector);
		if (!this.embedBlocks.length) return;

		this._init();
		this._clickPlay();
	}

	_init() {
		this._addYoutubeAPIScript();
		this._addVimeoAPIScript();
		this._registerIframes();
	}

	reindex(){
		this.embedBlocks = document.querySelectorAll(this.blockSelector);
		if (!this.embedBlocks.length) return;
		this._init();
		this._clickPlay();
	}

	_registerIframes() {
		setTimeout(() => {
			let iframes = document.querySelectorAll('iframe');
			iframes && iframes.forEach(iframe => {
				this._isVimeoEmbed(iframe) && this.embedList.push( new Vimeo.Player(iframe) );
				this._isYoutubeEmbed(iframe) && this.embedList.push( new YT.Player(iframe) );
			})
		}, 1000);
	}

	_clickPlay() {
		document.addEventListener('click', event => {
			if (
				event.target &&
				event.target.closest(this.coverSelector)
			) {
				event.preventDefault();
				const holder = event.target.closest(this.holderSelector);

				if (!holder) return;

				const iframe = holder.querySelector('iframe');

				this._handleYoutube(iframe);
				this._handleVimeo(iframe);
				this._handleDefault(iframe)
			}
		});
	}

	_addVimeoAPIScript() {
		this.embedBlocks.forEach(embed => {
			const iframe = embed.querySelector('iframe');
			if (!iframe || !this._isVimeoEmbed(iframe) || this.hasVimeoScript) return

			const tag = document.createElement('script');
			tag.src = "https://player.vimeo.com/api/player.js";
			const firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

			this.hasVimeoScript = true;

			return;
		})
	}

	_addYoutubeAPIScript() {
		this.embedBlocks.forEach(embed => {
			const iframe = embed.querySelector('iframe');

			if (!iframe || !this._isYoutubeEmbed(iframe)) return;

			this._enableYoutubeAPI(iframe);

			if (!this.hasYoutubeScript) {
				//youtube script
				const tag = document.createElement('script');
				tag.src = "https://www.youtube.com/iframe_api";
				const firstScriptTag = document.getElementsByTagName('script')[0];
				firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

				this.hasYoutubeScript = true;

				return;
			}
		})
	}

	_isYoutubeEmbed(iframe) {
		return iframe.src.indexOf('youtube.com') >= 0;
	}

	_isVimeoEmbed(iframe) {
		return iframe.src.indexOf('vimeo.com') >= 0;
	}

	_enableYoutubeAPI(iframe) {
		let url = new URL(iframe.src);

		url.searchParams.append("enablejsapi", 1);

		iframe.src = url;
	}

	_handleDefault(iframe) {
		if (!this._isVimeoEmbed(iframe) && !this._isYoutubeEmbed(iframe)) {
			const holder = iframe.closest(this.holderSelector);

			if (!holder) return;
			this._hideCover(holder);
		}
	}

	_handleVimeo(iframe) {
		if (!this._isVimeoEmbed(iframe)) return;

		const holder = iframe.closest(this.holderSelector);

		if (!holder) return;

		const player = this.getApi(iframe);

		player.play();

		player.on('play', () => {
			this._hideCover(holder);
		});

		player.on('ended', () => {
			this._showCover(holder);
		});
	}

	_handleYoutube(iframe) {
		const that = this;

		if (!this._isYoutubeEmbed(iframe)) return;

		const cover = iframe.closest(this.coverSelector);
		const holder = iframe.closest(this.holderSelector);

		if (!cover) return;

		let player = this.getApi(iframe);

		cover.insertAdjacentElement('afterbegin', iframe);

		player.addEventListener("onReady", onPlayerReady);

		function onPlayerReady(event) {
			that.play(event.target, holder)
			event.target.addEventListener("onStateChange", onPlayerStateChange);
		}

		function onPlayerStateChange(event) {
			if (event.data == YT.PlayerState.ENDED) {
				stopVideo();
			}
		}

		function stopVideo() {
			that._showCover(holder);
		}
	}

	play(player, holder) {
		this._hideCover(holder);
		player.playVideo();
	}

	getApi(iframe) {
		let embedApi = iframe && !iframe.tagName !== "IFRAME" ? this.embedList.filter(entry => entry.g === iframe || entry.element === iframe) : [];
		return embedApi.length ? embedApi[0] : false;
	}

	stopVideo(iframe) {
		let embedApi = this.getApi(iframe);
		if (!embedApi) return;
		if (embedApi.hasOwnProperty('g')) { }
		embedApi.hasOwnProperty('g') && embedApi.pauseVideo() && this._showCover(iframe.closest(this.holderSelector))
		embedApi.hasOwnProperty('element') && embedApi.pause() && this._showCover(iframe.closest(this.holderSelector))
	}

	_hideCover(holder) {
		const cover = holder.querySelector(this.coverSelector);
		cover.classList.add('hide');
	}

	_showCover(holder) {
		if (!holder.querySelector('img')) return;
		const cover = holder.querySelector(this.coverSelector);
		cover.classList.remove('hide');
	}
}
export const embedCover = new EmbedCover();
